module.exports = __webpack_public_path__ + "assets/img/club-image.134230fa.jpg";